import React from 'react';
import { Heading, Box } from '@wix/design-system';
export function SubHeader({ title, suffix = null }) {
    return (React.createElement(Box, { align: "space-between", gap: "10px", paddingBottom: "12px" },
        React.createElement(Heading, { size: "extraTiny" }, title),
        suffix));
}
//# sourceMappingURL=SubHeader.js.map